import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';
import BookLesson from './BookLesson';
import SVG from 'react-inlinesvg';
import { useBookContext } from './BookContext';
import { ChapterType, getChapterIndex } from '../../../ui/src/common/book/BookHelpers';
import { TranslateUnit } from '../../../common-sk-doc/src/Translater';
import config from '../../../common-sk-doc/src/config';

const BookChapter: React.FC<{
  chapter: any;
  index: number;
}> = ({ chapter, index }) => {
  const { book } = useBookContext();
  const lang = 0;

  return !!chapter ? (
    <section id={`section-${index}`}>
      {chapter.type === ChapterType.Default ? (
        <div className="book-card mb-3 p-2">
          <div
            className={`book-chapter ${book.type === 6 && 'book-chapter-checkpoint'
              }`}>
            <div className="chapter-index">
              {getChapterIndex(book.chapters, index)}
            </div>
            <div className="chapter-name">{chapter.name}.</div>
            <div className="chapter-title">{chapter.title}</div>
            {chapter.notificationStatus ? (
              <div className="chapter-notification d-flex me-3">
                <SVG
                  className="me-2"
                  src={config.ASSETS_PATH + '/icons/reload.svg'}
                />
                <span>{chapter.notification}</span>
              </div>
            ) : (
              <></>
            )}
          </div>
          {chapter.lessons.map((l, j) => (
            <BookLesson
              key={j}
              lesson={l}
            />
          ))}
        </div>
      ) : chapter.type === ChapterType.Parent ? (
        <h2 className="chapter-parent py-3">
          {chapter.name}. {chapter.title}
        </h2>
      ) : (
        <div className="book-card mb-3 p-2">
          <div className="book-chapter checkpoint-chapter">
            <div className="chapter-index">
              {getChapterIndex(book.chapters, index)}
            </div>
            <div className="checkpoint-lesson d-flex ">
              <div className="chapter-name">{chapter.name}.</div>
              <div className="chapter-title">{chapter.title}</div>
            </div>
            <div className="checkpoint-title">
              <Link
                to={`/checkpoints/${chapter.lessons[0]?.sections[0]?.skills[0]?.id}`}>
                <span className="title">
                  {chapter.lessons[0]?.sections[0]?.skills[0]?.name}
                </span>
                <span className="info">
                  {
                    chapter.lessons[0]?.sections[0]?.skills[0]?.checkpoint
                      ?.testTime
                  }{' '}
                  {TranslateUnit(
                    'minute',
                    'phút',
                    chapter.lessons[0]?.sections[0]?.skills[0]?.checkpoint
                      ?.testTime,
                    lang,
                  ).toLocaleLowerCase()}
                  {' - '}
                  {chapter.lessons[0]?.sections[0]?.skills[0]?.checkpoint?.checkpointHeaders
                    .map((h) =>
                      h.checkpointDetails
                        .map((d) => d.questionCount)
                        .reduce((a, b) => a + b, 0),
                    )
                    .reduce((a, b) => a + b, 0)}{' '}
                  {TranslateUnit(
                    'question',
                    'Câu',
                    chapter.lessons[0]?.sections[0]?.skills[0]?.checkpoint?.checkpointHeaders
                      .map((h) =>
                        h.checkpointDetails
                          .map((d) => d.questionCount)
                          .reduce((a, b) => a + b, 0),
                      )
                      .reduce((a, b) => a + b, 0),
                    lang,
                  ).toLocaleLowerCase()}
                </span>
              </Link>
            </div>
            <div className="checkpoint-icon">
              <FontAwesomeIcon
                icon={faTrophy}
              />
            </div>
          </div>
        </div>
      )}
    </section>
  ) : (
    <></>
  );
};

export default BookChapter;
